import type { UniqueIdentifier } from "@dnd-kit/core"
import { AnimateLayoutChanges, useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import React, { CSSProperties } from "react"

import { iOS } from "../../utilities"
import { Props as TreeItemProps, TreeItem } from "./TreeItem"

interface Props extends TreeItemProps {
  id: UniqueIdentifier
  parentDepth: number
  disableDrag?: boolean
  trackOrderPlaceholder?: string
}

const animateLayoutChanges: AnimateLayoutChanges = ({
  isSorting,
  wasDragging,
}) => !(isSorting || wasDragging)

export function SortableTreeItem({
  id,
  depth,
  parentDepth,
  disableDrag,
  trackOrderPlaceholder,
  ...props
}: Props) {
  const {
    attributes,
    isDragging,
    isSorting,
    listeners,
    setDraggableNodeRef,
    setDroppableNodeRef,
    transform,
    transition,
  } = useSortable({
    id,
    animateLayoutChanges,
    disabled: disableDrag,
  })
  const style: CSSProperties = {
    transform: CSS.Translate.toString(transform),
    transition,
  }

  return (
    <TreeItem
      ref={setDraggableNodeRef}
      wrapperRef={setDroppableNodeRef}
      style={style}
      depth={depth}
      parentDepth={parentDepth}
      ghost={isDragging}
      disableSelection={iOS}
      disableInteraction={isSorting}
      disableDrag={disableDrag}
      handleProps={
        disableDrag
          ? {}
          : {
              ...attributes,
              ...listeners,
            }
      }
      trackOrderPlaceholder={trackOrderPlaceholder}
      {...props}
    />
  )
}
